import accounting from 'accounting';

const number = (value, numberFormat) => {
    accounting.settings = {
        ...accounting.settings,
        number: numberFormat
    };

    return accounting.formatNumber(value);
};

export default number;
